import React from 'react';
import { validate } from '../validations';

export var RestPwdDialog = React.createClass({
    getInitialState() {
        return {
            errorMessage: null,
        }
    },

    submitResetPassword() {
        this.props.removeErrorMessage();
        let isValidnewPassword = validate.isValidPassword(this.refs.new_pwd.value.trim());
        isValidnewPassword ? this.refs.new_pwd.className = 'inputText' : this.refs.new_pwd.className = 'inputText error';
        let isValidConfirmPassword = validate.isValidPassword(this.refs.re_pwd.value.trim());
        isValidConfirmPassword ? this.refs.re_pwd.className = 'inputText' : this.refs.re_pwd.className = 'inputText error';

        if (this.refs.new_pwd.value.trim().length > 0 && this.refs.new_pwd.value.trim().length > 0) {

            if (isValidnewPassword && isValidConfirmPassword) {
                if (this.refs.new_pwd.value.trim() === this.refs.re_pwd.value.trim()) {
                    this.props.confirm(this, self)
                }
                else {
                    this.refs.new_pwd.className = 'inputText error';
                    this.refs.re_pwd.className = 'inputText error';
                    this.setState({ errorMessage: "Password and Confirm Password fields should match." });
                }
            }
            else {
                this.setState({ errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers." });
            }

        }
        else {
            this.setState({ errorMessage: "Please enter necessary fields to proceed." });
        }
    },

    componentWillReceiveProps(nextProps) {
        // To clear the password fields, if Server error occurs
        if (nextProps.errorMessage) {
            this.refs.new_pwd.value = '';
            this.refs.re_pwd.value = '';
        }
    },

    validatePassword() {
        if (this.refs.new_pwd.value.trim().length == 0) {
            this.setState({ errorMessage: "Please enter necessary fields to proceed." });
            this.refs.new_pwd.className = 'inputText error';
            return false;
        }

        let isValidpassword = validate.isValidPassword(this.refs.new_pwd.value.trim());
        isValidpassword ? this.refs.new_pwd.className = 'inputText' : this.refs.new_pwd.className = 'inputText error';
        if (isValidpassword) {
            this.setState({ errorMessage: null });
        } else {
            this.setState({
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            })
        }
    },

    validateConfirmPassword() {
        if (this.refs.re_pwd.value.trim().length == 0) {
            this.setState({ errorMessage: "Please enter necessary fields to proceed." });
            this.refs.re_pwd.className = 'inputText error';
            return false;
        }

        let isValidConfirmPassword = validate.isValidPassword(this.refs.re_pwd.value.trim());
        isValidConfirmPassword ? this.refs.re_pwd.className = 'inputText' : this.refs.re_pwd.className = 'inputText error';

        if (isValidConfirmPassword) {
            this.setState({ errorMessage: null });
        }
        else {
            this.setState({ errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers." });
        }
    },
    remove_error(event) {
        event.target.className = 'inputText';
        this.props.removeErrorMessage();
    },


    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },

    toggleConfirmPassword() {
        var confirmPwd = document.getElementById("confirmPassword");
        confirmPwd.type === "password" ? confirmPwd.type = "text" : confirmPwd.type = "password";
    },

    render() {
        var self = this;
        return (

            <div id="new-facility" className="modal fade in" role="dialog" style={{ display: 'block' }} >
                <div className="modal-content-text reset-password-modal">
                    <div className="modal-box">
                        <div className="modal-content text-center">
                            <h5>Reset Password</h5>
                            <div className="input-group">
                                <input type="password" className="inputText" ref="new_pwd" id="password" onFocus={this.remove_error} onBlur={this.validatePassword} maxLength="64" required />
                                <span className="floating-label" >New Password</span>

                                <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.togglePassword() }} />
                            </div>
                            <div className="input-group">
                                <input type="password" className="inputText" ref="re_pwd" id="confirmPassword"  onFocus={this.remove_error} onBlur={this.validateConfirmPassword} maxLength="64" required />
                                <span className="floating-label">Confirmation Password</span>
                                <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.toggleConfirmPassword() }} />
                            </div>

                            <label className="switch pull-right">
                                <input type="checkbox" ref="isPasswordChange" />
                                <div className="slider">No <spn className="yes-btn">Yes</spn></div>
                            </label>
                            <p>User must change password at next login</p>
                            {this.state.errorMessage && <div className="error-message">
                                <span className="red-color">{this.state.errorMessage} </span>
                            </div>}
                            {this.props.errorMessage && <div className="error-message"><span className="red-color">{this.props.errorMessage} </span></div>}
                            <button className="gray-button confirm" onClick={this.submitResetPassword}>SUBMIT</button>
                            <button className="white-button" onClick={this.props.cancel}>CANCEL</button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/reset_pwd_dialog.jsx
 **/